<div class="banner-carousel ion-padding-horizontal marb10">
  <swiper-container
    pager="false"
    [slidesPerView]="bannerList?.length > 1 ? 1.3 : 1"
    [freeMode]="true"
    [passiveListeners]="true"
    [spaceBetween]="20"
  >
    <swiper-slide class="padb10" *ngFor="let bannerItem of bannerList">
      <ion-card
        (click)="routeTo(bannerItem)"
        class="ion-no-margin border-r10"
      >
        <img
          [src]="bannerItem.carousel_img || imagePlaceholder"
          (ionError)="bannerItem.carousel_img = imagePlaceholder"
        />
        <div class="text-overlay" *ngIf="showLabel && bannerItem.title">
          <ion-card-title class="fs-4 font600">{{
            bannerItem.title
          }}</ion-card-title>
          <ion-card-subtitle class="fs-2 font400" *ngIf="bannerItem.tag">{{
            bannerItem.tag
          }}</ion-card-subtitle>
        </div>
      </ion-card>
    </swiper-slide>
  </swiper-container>
</div>
